<script setup lang="ts">

import { useBackButton } from "@app/Components/Utilities";

useBackButton();

</script>

<template>

    <div class="bg-white dark:bg-gray-850 tracking-wider text-sm lg:text-base
                 w-full h-full overflow-y-auto flex flex-col pb-12">

        <div class="flex justify-center items-center my-6">
            <strong class="text-lg font-bold">Had an accident?</strong>
        </div>     

        <div class="flex flex-col w-full gap-3 px-4 lg:px-6">
        
            <h1>
                Get Safe
            </h1>

            <div class="pl-2 lg:pl-4 flex flex-col w-full gap-3 dark:text-gray-300">
                <p>
                    Check that everyone is OK
                </p>
                <p>
                    In case of injury or hazard, dial <strong>000</strong> immediately
                </p>        
            </div>

            <h1>
                Get details
            </h1>

            <div class="pl-2 lg:pl-4 flex flex-col w-full gap-3 dark:text-gray-300">
                <p>
                    Write down the details of other drivers and vehicles involved in the accident.
                </p>
                <p>
                    You need to record the following information for each party:
                </p>
                <ul class="dark:text-white pl-5">
                    <li>Drivers full name</li>
                    <li>License number</li>
                    <li>Address</li>
                    <li>Phone number</li>
                    <li>Vehicle registration number</li>
                    <li>Their insurance details</li>
                </ul>        
                <p>
                    And record the following information about the accident
                </p>
                <ul class="dark:text-white pl-5">
                    <li>Time and date</li>
                    <li>Location</li>
                    <li>Names and phone numbers of any witnesses</li>
                </ul>        
            </div>

            <h1>
                Next Steps
            </h1>

            <div class="pl-2 lg:pl-4 flex flex-col w-full gap-3 dark:text-gray-300">
                <p>
                    Take photos of the accident, from as many angles as possible
                </p>
                <p class="font-bold dark:text-white">
                    Call 000 immediately if the other party(s) refuse to exchange the above details
                </p>
                <p>
                    If you are unable to drive your vehicle, organise a tow truck and remember 
                    to take your personal belongings from the car.
                </p>
                <p>
                    Contact your insurer and provide the details you have collected whilst it is still
                    fresh in your memory.
                </p>
            </div>

        </div>

    </div>   
    
</template>
